import { useMemo } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { IconButton, FilterAltIcon, PopoverDialog, usePopoverDialog, Dot } from '@frontend/design-system';
import { useReviewsFilterShallowStore } from '../../hooks';
import { ReviewsFilterMenu } from '../reviews-filter';

type ReviewFilterMenuProps = {
  disabled?: boolean;
};

export const ReviewFilterMenu = ({ disabled }: ReviewFilterMenuProps) => {
  const { getTriggerProps, getDialogProps } = usePopoverDialog<HTMLButtonElement | HTMLAnchorElement>({
    placement: 'bottom',
  });

  const { readFilter, repliedFilter, sortByNewest, startDate, endDate } = useReviewsFilterShallowStore(
    'readFilter',
    'repliedFilter',
    'sortByNewest',
    'startDate',
    'endDate'
  );

  const hasFilters = useMemo(
    () =>
      readFilter !== undefined ||
      repliedFilter !== undefined ||
      sortByNewest !== true ||
      startDate !== '' ||
      endDate !== '',
    [readFilter, repliedFilter, sortByNewest, startDate, endDate]
  );

  return (
    <section>
      <IconButton
        css={css`
          color: ${theme.colors.neutral50};
        `}
        {...getTriggerProps()}
        label='filter'
        disabled={disabled}
      >
        <FilterAltIcon color='light' />
        {hasFilters && (
          <Dot
            color='primary'
            css={{
              width: theme.spacing(1.5),
              height: theme.spacing(1.5),
              top: 2,
              right: 0,
              border: `1.5px solid ${theme.colors.white}`,
            }}
          />
        )}
      </IconButton>

      <PopoverDialog
        {...getDialogProps()}
        css={css`
          width: 302px;
          max-height: calc(100% - 200px);
          overflow: auto;
          border-radius: ${theme.borderRadius.medium};
          padding: ${theme.spacing(1, 0)};
        `}
      >
        <ReviewsFilterMenu />
      </PopoverDialog>
    </section>
  );
};

export default ReviewFilterMenu;
